module.exports = __webpack_public_path__ + "static/media/back2.fd091bbb.jpg";